module.exports = __webpack_public_path__ + "0ed3e1dd88b9a79ac9643c4fd2467d5c.svg";